import React, { useState } from 'react';
import Button from 'src/app/atoms/Button/Button';
import Input from 'src/app/atoms/Input/Input';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import Typography from 'src/app/atoms/Typography/Typography';
import Arrow from 'src/app/icons/Monospaced/Arrow/Arrow';
import useIdealMemberSubmission from 'src/hooks/useIdealMemberSubmission';
import useOnEnterExecute from 'src/hooks/useOnEnterExecute';

export interface IdealMemberInputProps {
  placeholder: string;
  hint: string;
}

const IdealMemberInput = ({ placeholder, hint }: IdealMemberInputProps): JSX.Element => {
  const [value, setValue] = useState('');

  const { handleIdealMemberSubmit, inputError } = useIdealMemberSubmission(value);

  const handleSubmit = (e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (!value) return;

    handleIdealMemberSubmit(e);
  };

  const handleKeyDown = useOnEnterExecute((e) =>
    handleSubmit(e as unknown as React.MouseEvent<HTMLButtonElement, MouseEvent>)
  );

  return (
    <Stack
      direction='column'
      gap='spacing-sm'
    >
      <Input
        placeholder={placeholder}
        size='md'
        onKeyDown={handleKeyDown}
        value={value}
        onChange={(e) => setValue(e)}
        error={inputError}
        rightElement={
          <Button
            size='sm'
            variant='primary'
            onClick={handleSubmit}
            icon={
              <Arrow
                orientation='up'
                width={20}
                color='var(--brand-950)'
              />
            }
          />
        }
      />
      <Typography
        type='paragraph'
        size='xs'
        color='text-white'
        textAlign='center'
      >
        {hint}
      </Typography>
    </Stack>
  );
};

export default IdealMemberInput;
